
import * as defaultImport from "numeral";
export * from "numeral";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
